<template>
  <div class="modal right fade" :id="componentID" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog" role="document">
<!--      <button type="button" class="close md-close" @click="closeWarning('#'+objectModalName.question)" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
      <div class="modal-content">

        <div class="modal-header">
          <h4 class="modal-title text-center" v-if="currentGap.id">GAP Eintrag</h4>
          <h4 class="modal-title text-center" v-else>neuer GAP Eintrag</h4>
          <button type="button" class="close xs-close" data-dismiss="modal" @click="closeWarning('#'+objectModalName.question)">×</button>
        </div>

        <div class="modal-body">
          <form>
            <accordion :oneOpen="false">
            <template v-slot:content>
              <div class="form-group row" v-show="!currentGap.id">
                <div class="col-md-12">
                  <SelectGapQuestion @questionChanged="updateQuestionID" :irrelevant="true" component-name="selectGapQuestion" :type="type"></SelectGapQuestion>
                  <div class="input-errors" v-for="error of v$.currentGap.id.$errors" :key="error.$uid">
                    <div class="error-msg text-danger">{{ $t('required_field') }}</div>
                  </div>
                </div>
              </div>
              <accordion-item title="GAP Fragekatalog" :isActive="true">
                <template v-slot:content>
                  <div class="form-group row">
                    <div class="col-sm-12">
                      <label class="col-form-label">Beschreibung</label>
                      <textarea class="form-control" rows="3" placeholder="Beschreibung" v-model="currentGap.description" readonly></textarea>
                    </div>
                  </div>
                </template>
              </accordion-item>
              <accordion-item title="Anforderung aus DSGVO">
                <template v-slot:content>
                  <p>{{currentGap.topic.name}} / {{currentGap.category}}</p>
                </template>
              </accordion-item>
              <accordion-item title="Mögliche Maßnahmen">
                <template v-slot:content>
                  <p>{{currentGap.possible_task}}</p>
                </template>
              </accordion-item>
              <accordion-item title="Iststand" :activeAccordion="false" :isActive="true" v-if="currentGap.id">
                <template v-slot:title>
                  <span :class="addNewAnswer ? '' : 'mb-3'">Iststand
                    <a class="dkl-btn btn-md rounded-circle" href="#" @click.prevent="showNewAnswer" v-show="!addNewAnswer"><i class="fa fa-plus" aria-hidden="true"></i></a>
                    <a class="dkl-btn btn-md rounded-circle" href="#" @click.prevent="addNewAnswer=false" v-show="addNewAnswer"><i class="fa fa-minus" aria-hidden="true"></i></a>
                  </span>
                </template>
                <template v-slot:content>
                  <div v-if="addNewAnswer">
                    <new-gap-stand-component :currentAnswer="currentAnswer" @standUpdated="saveNewAnswer" :current-gap="currentGap"></new-gap-stand-component>
                  </div>
                  <div v-if="Object.keys(currentGap.last_answer).length > 0" class="m-t-5">
                    <h4 class="card-title">
                      Letzter Iststand
                    </h4>
                    <div class="form-group row">
                      <label class="col-form-label col-md-2">Iststand</label>
                      <div class="col-md-10">
                        <textarea class="form-control" v-model="currentGap.last_answer.question_answer" readonly></textarea>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-form-label col-md-2">Dokumenten</label>
                      <div class="col-md-10">
                        <input type="text" class="form-control" v-model="currentGap.last_answer.document" readonly>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6 d-flex">
                        <label class="col-form-label" style="padding-left: 0px; padding-right: 45px">mitgeteilt von</label>
                        <div>
                          <input type="text" class="form-control col-auto" v-model="currentGap.last_answer.given_by" readonly>
                        </div>
                      </div>
                      <div class="col-md-6 d-flex">
                        <label class="col-form-label col-auto">Stand</label>
                        <div>
                          <input type="text" class="form-control col-auto" v-model="currentGap.last_answer.stand" readonly>
                          <div class="p-2 bg-light">
                            <div class="float-right">
                              <button type="button" class="btn btn-sm btn-danger" @click="deleteAnswer(currentGap.last_answer.id)">
                                <i class='uil uil-message me-1'></i>löschen
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="Object.keys(currentGap.last_answer).length > 0" class="m-t-5">
                    <h4 class="card-title">
                      ältere Enträge
                    </h4>
                    <table class="table table-striped mb-0">
                      <tbody>
                      <tr v-for="(answer, index) in currentGap.answers.filter(p => p.id !== currentGap.last_answer.id)" :key="index">
                        <td>{{answer.question_answer }}</td>
                        <td>{{answer.given_by}}</td>
                        <td>{{answer.stand}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </template>
              </accordion-item>
              <div v-else>Gap muss zuerst gespeichert werden bevor Iststand geflegt werden kann!</div>
              <accordion-item title="Maßnahmen">
                <template v-slot:title>
                  <span>Maßnahmen
                    <a class="dkl-btn btn-md rounded-circle" @click.prevent="$emit('openTaskModal')" v-show="currentGap.id" href="#"><i class="fa fa-plus" aria-hidden="true"></i></a>
                  </span>
                </template>
                <template v-slot:content>
                  <div class="form-group row" v-for="task in currentGap.tasks" :key="task.id">
                    <!-- task description -->
                    <div class="col-4">
                      <p class="mt-2 mb-1 text-muted">Aufgabe Inhalt</p>
                      <p>{{task.description}}</p>
                    </div>
                    <div class="col-2">
                      <!-- assignee -->
                      <p class="mt-2 mb-1 text-muted">Liegt bei</p>
                      <p>{{task.assigned_to_char}}</p>
                      <!-- end assignee -->
                    </div> <!-- end col -->
                    <div class="col-2">
                      <!-- start due date -->
                      <p class="mt-2 mb-1 text-muted">umzusetzen</p>
                      <p>{{task.due_date}}</p>
                      <!-- end due date -->
                    </div> <!-- end col -->
                    <div class="col-4">
                      <!-- start sub tasks/checklists -->
                      <p class="mt-2 mb-1 text-muted">Schritte</p>
                      <div v-for="step in task.steps" :key="'step-' + step.id">
                        <label class="form-check-label" for="'checklist'+step.id">
                          {{step.name}}
                        </label>
                      </div>
                    </div> <!-- end col -->
                    <!-- end task description -->
                  </div>
                </template>
              </accordion-item>
              <div class="text-center py-3">
                <button type="button" class="btn btn-secondary btn-rounded" @click="closeWarning('#'+objectModalName.question)">Schließen</button>
              </div>
            </template>
          </accordion>
          </form>
        </div>

      </div><!-- modal-content -->
    </div><!-- modal-dialog -->
  </div>
</template>

<script>
import {service, baseURL} from '@/utils/request.js';
import {newAnswer, objectModalName} from '@/utils/enums'
import {mapState, mapMutations} from 'vuex';
import {required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import {deepCopy, closeWarning, deleteAction} from "@/utils";
import AccordionComponent from "@/components/component/AccordionComponent.vue";
import AccordionItemComponent from '@/components/component/AccordionItemComponent.vue'
import SelectGapQuestion from "@/components/component/SelectGapQuestion.vue";
import NewGapStandComponent from "@/components/component/NewGapStandComponent.vue";

export default {
  name: "GapComponent",
  components: {NewGapStandComponent, SelectGapQuestion, accordion: AccordionComponent, accordionItem: AccordionItemComponent},
  props: {
    currentGap: {
      type: Object,
      required: true,
    },
    componentID: {
      type: String,
      default: 'related_gap'
    },
    type: {
      type: String,
      default: 'DS'
    },
    taskReturnGap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentAnswer: {},
      addNewAnswer: false,
      newQuestionID: null,
      objectModalName: objectModalName
    }
  },
  validations() {
    return {
      currentAnswer: {
        comments: {required, $lazy: true},
        stand: {required, $lazy: true}
      },
      currentGap: {
        id: {required, $lazy: true}
      }
    }
  },
  setup() {
    return {
      v$: useVuelidate()
    }
  },
  mounted() {
    $('#' + objectModalName.question).on('hidden.bs.modal', () => {
      if (!this.taskReturnGap) this.addNewAnswer = false
    })
  },
  beforeDestroy() {
    $('#' + objectModalName.question).off('hidden.bs.modal')
  },
  computed: {
    ...mapState({accountid: state => state.account.accountid, userName: state => state.user.username, account: state => state.account, userID: state => state.user.id, edit: state => state.app.edit,
      modalDirty: state => state.app.modalDirty,}),
  },
  methods: {
    ...mapMutations({setEdit: 'SET_EDIT', setModalDirty: 'SET_MODALDIRTY'}),
    closeWarning,
    deleteAnswer(answerID) {
      deleteAction(() => {
        service.request({
          url: `todos/v1/delete_answer/${answerID}/`,
          method: 'DELETE',
          responseType: 'json',
        }).then((response) => {
          if (this.currentGap.answers[0].id === parseInt(answerID)) {
            this.currentGap.answers.splice(0, 1)
            if (this.currentGap.answers.length > 0) {
              this.currentGap.last_answer = this.currentGap.answers[0]
            } else {
              this.currentGap.last_answer = {}
            }
          }
          this.$emit('gapUpdated', this.currentGap)
        })
      })
    },
    updateQuestionID(questionObject) {
      this.currentGap = questionObject
    },
    async saveNewAnswer(answerObject, generateTask) {
      this.currentGap.answers.push(answerObject)
      this.currentGap.last_answer = answerObject
      this.currentGap.last_answer.question_answer = answerObject.comments
      this.addNewAnswer = false
      this.$emit('gapUpdated', this.currentGap, generateTask)
      this.setModalDirty(false)
    },
    showNewAnswer(e) {
      e.preventDefault();
      const dateFormatOptions = {day: '2-digit', month: '2-digit', year: 'numeric'}
      this.currentAnswer = deepCopy(newAnswer)
      this.currentAnswer.given_by = this.userName;
      this.currentAnswer.question = this.currentGap.id
      this.currentAnswer.yes = this.currentGap.statement_yes
      this.currentAnswer.no = this.currentGap.statement_no
      this.currentAnswer.partial = this.currentGap.statement_partial
      this.currentAnswer.stand = new Date().toLocaleDateString('de', dateFormatOptions)
      if (this.currentGap.last_answer) this.currentAnswer.document = this.currentGap.last_answer.document
      this.addNewAnswer = true;
    },
  }
}
</script>

<style scoped>
.close {
  right: 25px;
  top: 20px;
}

</style>
